import request from '@/utils/request'
import APIS from '@/permissions/index'
// 分页查询回款记录
export function queryShareCollect (params) {
  return request({
    ...APIS['@shareIncome/Query_ShareCollect'],
    params
  })
}

export function queryCalculationCollect (params) {
  return request({
    ...APIS['@shareIncome/Query_CalculationCollect'],
    params
  })
}

export function exportCalculationCollect (params) {
  const headers = {
    'Content-Type': 'application/octet-stream'
  }
  const responseType = 'arraybuffer'
  return request({
    ...APIS['@shareIncome/Export_CalculationCollect'],
    params,
    headers,
    responseType
  })
}

export function exportShareIncome (params) {
  const headers = {
    'Content-Type': 'application/octet-stream'
  }
  const responseType = 'arraybuffer'
  return request({
    ...APIS['@shareIncome/Export_ShareIncome'],
    params,
    headers,
    responseType
  })
}
